import React, { useState } from 'react';
import { submitBetaKeyRequest } from '../../DatabaseAPI';

function BetaKeyRequest({ onBack }) {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    
    // Response states
    const [autoApproved, setAutoApproved] = useState(false);
    const [betaKey, setBetaKey] = useState('');
    const [existingKey, setExistingKey] = useState('');
    const [pendingApproval, setPendingApproval] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        try {
            console.log('🔑 BetaKeyRequest: Submitting request for:', email);
            const response = await submitBetaKeyRequest(email);
            // Response embeds a freshly issued key — log the outcome only.
            console.log('🔑 BetaKeyRequest: Response received, success:', response.success);

            if (response.success) {
                if (response.auto_approved) {
                    // CASE 1: Automatic approval - instant key.
                    // Key not logged: it is rendered on screen for the user and
                    // does not also belong in console/session-replay capture.
                    console.log('✅ BetaKeyRequest: AUTO-APPROVED, key issued');
                    setAutoApproved(true);
                    setBetaKey(response.beta_key);
                } else if (response.existing_key) {
                    // CASE 2: User already has a key - return existing
                    console.log('ℹ️ BetaKeyRequest: EXISTING KEY found');
                    setExistingKey(response.existing_key);
                } else {
                    // CASE 3: Manual approval required - pending
                    console.log('⏳ BetaKeyRequest: PENDING APPROVAL');
                    setPendingApproval(true);
                }
            } else {
                // Error from backend
                setError(response.message || 'Request failed. Please try again.');
            }
        } catch (error) {
            console.error('❌ BetaKeyRequest: Error:', error);
            setError(error.message || 'Failed to submit request. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    // SUCCESS SCREEN 1: Auto-Approval (Instant Key)
    if (autoApproved && betaKey) {
        return (
            <div style={{ 
                maxWidth: '500px', 
                margin: '0 auto', 
                padding: '40px 20px',
                fontFamily: 'Arial, sans-serif'
            }}>
                <div style={{
                    backgroundColor: '#27ae60',
                    color: 'white',
                    padding: '30px',
                    borderRadius: '8px',
                    textAlign: 'center',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                }}>
                    <div style={{ fontSize: '64px', marginBottom: '20px' }}>🎉</div>
                    <h2 style={{ marginTop: '0', marginBottom: '20px', fontSize: '28px' }}>
                        Approved Instantly!
                    </h2>
                    <p style={{ fontSize: '16px', lineHeight: '1.6', marginBottom: '25px' }}>
                        Your beta key request for <strong>{email}</strong> has been automatically approved!
                    </p>
                    
                    <div style={{
                        backgroundColor: '#229954',
                        padding: '20px',
                        borderRadius: '6px',
                        marginBottom: '25px'
                    }}>
                        <div style={{ fontSize: '14px', marginBottom: '10px', opacity: 0.9 }}>
                            Your Beta Key:
                        </div>
                        <div style={{ 
                            fontSize: '24px', 
                            fontWeight: 'bold', 
                            letterSpacing: '2px',
                            fontFamily: 'monospace'
                        }}>
                            {betaKey}
                        </div>
                    </div>
                    
                    <p style={{ fontSize: '14px', marginBottom: '25px', color: '#ecf0f1', lineHeight: '1.5' }}>
                        Use this key to create your account and start playing!<br/>
                        Save it somewhere safe or check your email for a copy.
                    </p>
                    
                    <button
                        onClick={onBack}
                        style={{
                            backgroundColor: '#2c3e50',
                            color: 'white',
                            padding: '14px 28px',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            fontWeight: 'bold'
                        }}
                    >
                        ← Back to Login
                    </button>
                </div>
            </div>
        );
    }

    // SUCCESS SCREEN 2: Existing Key (User Already Has One)
    if (existingKey) {
        return (
            <div style={{ 
                maxWidth: '500px', 
                margin: '0 auto', 
                padding: '40px 20px',
                fontFamily: 'Arial, sans-serif'
            }}>
                <div style={{
                    backgroundColor: '#3498db',
                    color: 'white',
                    padding: '30px',
                    borderRadius: '8px',
                    textAlign: 'center',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                }}>
                    <div style={{ fontSize: '64px', marginBottom: '20px' }}>💼</div>
                    <h2 style={{ marginTop: '0', marginBottom: '20px', fontSize: '28px' }}>
                        You Already Have a Beta Key!
                    </h2>
                    <p style={{ fontSize: '16px', lineHeight: '1.6', marginBottom: '25px' }}>
                        Good news! The email <strong>{email}</strong> already has an active beta key.
                    </p>
                    
                    <div style={{
                        backgroundColor: '#2980b9',
                        padding: '20px',
                        borderRadius: '6px',
                        marginBottom: '25px'
                    }}>
                        <div style={{ fontSize: '14px', marginBottom: '10px', opacity: 0.9 }}>
                            Your Existing Beta Key:
                        </div>
                        <div style={{ 
                            fontSize: '24px', 
                            fontWeight: 'bold', 
                            letterSpacing: '2px',
                            fontFamily: 'monospace'
                        }}>
                            {existingKey}
                        </div>
                    </div>
                    
                    <p style={{ fontSize: '14px', marginBottom: '25px', color: '#ecf0f1', lineHeight: '1.5' }}>
                        Use this key to log in or create your account.<br/>
                        If you've lost access, contact us at <strong>support@mythicfootball.com</strong>
                    </p>
                    
                    <button
                        onClick={onBack}
                        style={{
                            backgroundColor: '#2c3e50',
                            color: 'white',
                            padding: '14px 28px',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            fontWeight: 'bold'
                        }}
                    >
                        ← Back to Login
                    </button>
                </div>
            </div>
        );
    }

    // SUCCESS SCREEN 3: Pending Approval (Manual Review Required)
    if (pendingApproval) {
        return (
            <div style={{ 
                maxWidth: '500px', 
                margin: '0 auto', 
                padding: '40px 20px',
                fontFamily: 'Arial, sans-serif'
            }}>
                <div style={{
                    backgroundColor: '#f39c12',
                    color: 'white',
                    padding: '30px',
                    borderRadius: '8px',
                    textAlign: 'center',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                }}>
                    <div style={{ fontSize: '64px', marginBottom: '20px' }}>📧</div>
                    <h2 style={{ marginTop: '0', marginBottom: '20px', fontSize: '28px' }}>
                        Request Submitted!
                    </h2>
                    <p style={{ fontSize: '16px', lineHeight: '1.6', marginBottom: '25px' }}>
                        Thank you for your interest in Mythic Football! We've received your beta key request for <strong>{email}</strong>.
                    </p>
                    
                    <div style={{
                        backgroundColor: '#e67e22',
                        padding: '20px',
                        borderRadius: '6px',
                        marginBottom: '25px',
                        textAlign: 'left'
                    }}>
                        <p style={{ margin: '0 0 10px 0', fontSize: '15px', fontWeight: 'bold' }}>
                            📝 What's Next?
                        </p>
                        <ul style={{ margin: '0', paddingLeft: '20px', fontSize: '14px', lineHeight: '1.8' }}>
                            <li>Our team will review your request</li>
                            <li>You'll receive an email with your beta key when approved</li>
                            <li>Typical response time: 24-48 hours</li>
                        </ul>
                    </div>
                    
                    <p style={{ fontSize: '13px', marginBottom: '25px', color: '#ecf0f1', lineHeight: '1.5' }}>
                        Keep an eye on your inbox! If you don't hear from us within 48 hours,<br/>
                        please contact <strong>support@mythicfootball.com</strong>
                    </p>
                    
                    <button
                        onClick={onBack}
                        style={{
                            backgroundColor: '#2c3e50',
                            color: 'white',
                            padding: '14px 28px',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            fontWeight: 'bold'
                        }}
                    >
                        ← Back to Login
                    </button>
                </div>
            </div>
        );
    }

    // REQUEST FORM (Initial State)
    return (
        <div style={{ 
            maxWidth: '500px', 
            margin: '0 auto', 
            padding: '40px 20px',
            fontFamily: 'Arial, sans-serif'
        }}>
            <div style={{
                backgroundColor: '#2c3e50',
                color: 'white',
                padding: '30px',
                borderRadius: '8px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
            }}>
                <h2 style={{ 
                    textAlign: 'center', 
                    marginTop: '0',
                    marginBottom: '25px',
                    fontSize: '26px'
                }}>
                    📧 Request Beta Key
                </h2>

                {error && (
                    <div style={{
                        backgroundColor: '#e74c3c',
                        color: 'white',
                        padding: '15px',
                        borderRadius: '4px',
                        marginBottom: '20px',
                        fontSize: '14px'
                    }}>
                        ❌ {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '25px' }}>
                        <label htmlFor="email" style={{ 
                            display: 'block', 
                            marginBottom: '10px',
                            fontWeight: 'bold',
                            fontSize: '15px'
                        }}>
                            Email Address:
                        </label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            disabled={isLoading}
                            style={{
                                width: '100%',
                                padding: '14px',
                                borderRadius: '4px',
                                border: '2px solid #bdc3c7',
                                fontSize: '16px',
                                boxSizing: 'border-box',
                                backgroundColor: isLoading ? '#ecf0f1' : 'white'
                            }}
                            placeholder="your.email@example.com"
                        />
                        <small style={{ color: '#95a5a6', fontSize: '13px', marginTop: '8px', display: 'block' }}>
                            We'll send your beta key to this email address
                        </small>
                    </div>

                    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                        <button
                            type="submit"
                            disabled={isLoading || !email}
                            style={{
                                backgroundColor: isLoading ? '#95a5a6' : '#3498db',
                                color: 'white',
                                padding: '14px 32px',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: isLoading ? 'not-allowed' : 'pointer',
                                fontSize: '17px',
                                fontWeight: 'bold',
                                marginRight: '12px',
                                minWidth: '160px'
                            }}
                        >
                            {isLoading ? '⏳ Submitting...' : '🚀 Request Beta Key'}
                        </button>

                        <button
                            type="button"
                            onClick={onBack}
                            disabled={isLoading}
                            style={{
                                backgroundColor: '#95a5a6',
                                color: 'white',
                                padding: '14px 32px',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: isLoading ? 'not-allowed' : 'pointer',
                                fontSize: '17px',
                                fontWeight: 'normal'
                            }}
                        >
                            ← Back
                        </button>
                    </div>
                </form>

                <div style={{ 
                    marginTop: '30px', 
                    padding: '20px',
                    backgroundColor: '#34495e',
                    borderRadius: '6px',
                    fontSize: '14px',
                    lineHeight: '1.6'
                }}>
                    <p style={{ margin: '0 0 10px 0', fontWeight: 'bold', fontSize: '15px' }}>
                        🎯 What's Next?
                    </p>
                    <p style={{ margin: '0' }}>
                        Once you receive your beta key, you'll be able to create your account and join leagues. 
                        Beta keys are distributed based on availability - some are instant, others require review.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default BetaKeyRequest;